export default __webpack_public_path__ + "static/media/mother.75206320.jpg";